class ActivityLog {
    id = null;
    seafarer_id = null;
    seafarer_status_id = null;
    start_date = null;
    end_date = null;
    placement_id = null;
    placement_info = '';
    rank_id = null;
    rank_info = '';
    contract_id = null;
    day_type = null;
    note = null;
    duration = '';
    user_id = null;
    inactive_reason_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default ActivityLog;
